import MapboxDraw, { DrawCustomMode, DrawCustomModeThis } from "@mapbox/mapbox-gl-draw";
import { Position } from "geojson";

import { DRAWING_CONSTANTS } from "fond/constants";
import { LayerIds } from "fond/types";

import drawPointMode from "../../base/drawPoint";
import { canPlacePoint } from "../../base/helper";

import { onCreateAerialPole } from "./onCreateAerialPole";

const { constants: Constants } = MapboxDraw;

/*
 * A modified draw_point mode that stays in draw_point when a point is created,
 * rather than moving back to simple_select and requiring the user to re-enter
 * draw point mode to create the next point.
 */
function addPoint(this: DrawCustomModeThis, coordinates: Position): MapboxDraw.DrawPoint {
  const point = this.newFeature({
    type: Constants.geojsonTypes.FEATURE,
    properties: { layerId: LayerIds.inPole, [DRAWING_CONSTANTS.Unsnapped]: "true" },
    geometry: {
      type: Constants.geojsonTypes.POINT,
      coordinates,
    },
  }) as MapboxDraw.DrawPoint;

  this.addFeature(point);

  return point;
}

/**
 * This is a custom mode for drawing poles in the aerial planner.
 * It extends the draw_point mode and adds functionality for snapping to spans.
 * It also handles the creation of poles and splitting paths when a pole is dropped on a span.
 */
const drawPole: DrawCustomMode = {
  ...drawPointMode,

  onClick: function (this, state, e) {
    if (!canPlacePoint(state, e)) return;

    const feature = addPoint.call(this, [state.snappedLng, state.snappedLat]);

    onCreateAerialPole.call(this, feature, state);
  },
};

export default drawPole;
